import {
  FeedbackDetailsCommonMetadata,
  FeedbackDetailsMetadataCard,
} from '@modules/feedback/components/FeedbackDetails/FeedbackDetailsRightPanel';
import { FeedbackDetailsPredictions } from '@modules/feedback/components/FeedbackDetails/FeedbackDetailsRightPanel/FeedbackDetailsPredictions';

import { SetSelectedLabels } from '@modules/feedback/types';
import { getSortedFeedbackSourceMetadataFields } from '@modules/feedback/utils';
import { Box, Stack } from '@mui/material';
import { ObjectType } from 'generated/graphql';
import { Dispatch, SetStateAction } from 'react';
import { Feedback, FeedbackLabel } from 'v2/core/entities/feedback';

interface FeedbackDetailsRightPanelProps {
  feedback: Feedback;
  setSelectedLabels: SetSelectedLabels;
  selectedLabels: FeedbackLabel[];
  showOriginalLanguage: boolean;
  setShowOriginalLanguage: Dispatch<SetStateAction<boolean>>;
}

export const FeedbackDetailsRightPanel = ({
  feedback,
  setSelectedLabels,
  selectedLabels,
  showOriginalLanguage,
  setShowOriginalLanguage,
}: FeedbackDetailsRightPanelProps) => {
  const metadataFields = getSortedFeedbackSourceMetadataFields({
    metadataFields: feedback.sourceV2?.metadata,
  });

  return (
    <Box
      sx={{
        width: 1 / 3,
        position: 'sticky',
        top: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      <Stack spacing={2}>
        <FeedbackDetailsPredictions
          feedback={feedback}
          selectedLabels={selectedLabels}
          setSelectedLabels={setSelectedLabels}
        />
        <FeedbackDetailsCommonMetadata
          feedback={feedback}
          setShowOriginalLanguage={setShowOriginalLanguage}
          showOriginalLanguage={showOriginalLanguage}
        />
        <FeedbackDetailsMetadataCard
          metadataFields={metadataFields}
          objectType={ObjectType.Feedback}
          feedbackID={feedback.id}
        />
        <FeedbackDetailsMetadataCard
          metadataFields={metadataFields}
          objectType={ObjectType.User}
          feedbackID={feedback.id}
        />
        <FeedbackDetailsMetadataCard
          metadataFields={metadataFields}
          objectType={ObjectType.Account}
          feedbackID={feedback.id}
        />
      </Stack>
    </Box>
  );
};
